/**
 * The text frame the Spell Check panel is peeking into, if any.
 *
 * Opening a misspelling that sits in overflow text (WMPCM-1212, SC-5) shows that frame's hidden
 * text on the canvas until the popover closes. The panel decides which frame and the frame paints
 * the peek, and the two do not share a parent, so this module-level store, like the underline
 * store next to it, carries the one id between them. At most one frame peeks at a time.
 */
let peekedShapeId: string | null = null
const listeners = new Set<() => void>()

function notify(): void {
  listeners.forEach((listener) => listener())
}

/** Peeks into one frame, or into none with `null`. Subscribers are told only on a change. */
export function setSpellPeek(shapeId: string | null): void {
  if (peekedShapeId === shapeId) return

  peekedShapeId = shapeId
  notify()
}

export function getSpellPeek(): string | null {
  return peekedShapeId
}

export function subscribeToSpellPeek(listener: () => void): () => void {
  listeners.add(listener)

  return () => {
    listeners.delete(listener)
  }
}
